import { useState } from "react";

// Shared circular avatar used everywhere a rep is represented (leaderboard,
// competition standings, team grid, user card). Renders the rep's photo when
// one is on file, cropping it to the circle (object-cover) so head-and-shoulders
// portraits frame cleanly. Falls back to the rep's initials on a gradient when
// there's no photo or the image fails to load.
//
// `className` controls SIZE + SHAPE (e.g. "h-16 w-16 rounded-full text-xl") and
// is applied to both the image and the fallback so they're interchangeable.
// `fallbackClassName` carries the gradient/colors used only by the initials state.
export default function Avatar({
  src,
  name,
  className = "",
  fallbackClassName = "bg-gradient-to-br from-amber-400 to-amber-600 text-ink-900",
}: {
  src?: string | null;
  name: string;
  className?: string;
  fallbackClassName?: string;
}) {
  const [failed, setFailed] = useState(false);
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  if (src && !failed) {
    return (
      <img
        src={src}
        alt={name}
        decoding="async"
        onError={() => setFailed(true)}
        className={"shrink-0 bg-ink-900 object-cover " + className}
      />
    );
  }
  return (
    <span
      className={"flex shrink-0 items-center justify-center font-bold " + fallbackClassName + " " + className}
      aria-label={name}
    >
      {initials}
    </span>
  );
}
